import React from 'react';
import { motion } from 'framer-motion';
import { Star, ChevronRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-6 md:pt-10 pb-12 md:pb-20 overflow-hidden" data-id="element-66">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-67"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 md:pt-6" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center text-center space-y-6" data-id="element-69">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight" data-id="element-70">
            Sistema PRO: <br data-id="element-71" />
            <span className="gold-gradient-text" data-id="element-72">Psiquiatría</span>
          </h1>
        </motion.div>

        {/* Product Image — below title */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative cursor-pointer group mt-10 md:mt-14 max-w-[70%] mx-auto" onClick={scrollToPricing} data-id="element-73">
          <div className="absolute inset-0 bg-gold/20 rounded-2xl blur-2xl group-hover:bg-gold/30 transition-colors duration-500" data-id="element-74"></div>
          <img src="https://cdn.magicpatterns.com/uploads/c62H19RLirTEYj6KNKHnKc/Gemini_Generated_Image_yh8gp7yh8gp7yh8g-Photoroom.png" alt="Sistema PRO Psiquiatría" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl transform group-hover:-translate-y-2 transition-transform duration-500" data-id="element-75" />
        </motion.div>

        {/* Subtitle — below mockup */}
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.35
      }} className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto text-center mt-8" data-id="element-76">
          Recursos avanzados, protocolos clínicos y herramientas de gestión para
          psiquiatras que quieren ejercer con precisión, autoridad y respaldo
          legal.
        </motion.p>

        {/* CTA + Rating — below subtitle */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col items-center mt-10 space-y-6" data-id="element-77">
          <a href="#pricing" onClick={scrollToPricing} className="group relative inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg font-bold text-navy bg-gold rounded-lg overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(201,168,76,0.4)]" data-id="element-78">
            <span className="relative z-10 flex items-center text-[16px]" data-id="element-79">
              👉 Acceder al Sistema PRO ahora
              <ChevronRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-80" />
            </span>
            <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-81"></div>
          </a>

          <div className="flex flex-col sm:flex-row items-center gap-4 pt-6 border-t border-navy-lighter w-full max-w-lg justify-center" data-id="element-82">
            <div className="flex items-center space-x-1" data-id="element-83">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-84" />)}
              <span className="ml-2 font-bold text-white" data-id="element-85">4.9/5</span>
            </div>
            <p className="text-sm text-gray-400 text-center sm:text-left" data-id="element-86">
              <span className="text-white font-medium" data-id="element-87">
                Elegido por psiquiatras en toda Argentina
              </span>
              <br data-id="element-88" />
              El sistema de documentación clínica psiquiátrica más completo y
              profesional del mercado
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}